import React from 'react';
import { toast } from 'react-toastify';

const useToastNotification = () => {
  const toastId = 'global-toast-id';

  const showError = (message, time = 7000) => {
    if (typeof message === 'object') {
      message = message.text;
    }

    if (toast.isActive(toastId)) {
      toast.update(toastId, {
        render: message,
        type: 'error',
        autoClose: time,
        isLoading: false,
      });
    } else {
      toast.error(message, {
        toastId,
        position: 'top-center',
        autoClose: time,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const showSuccess = (message, time = 7000) => {
    if (typeof message === 'object') {
      message = message.text;
    }

    if (toast.isActive(toastId)) {
      toast.update(toastId, {
        render: message,
        type: 'success',
        autoClose: time,
        isLoading: false,
      });
    } else {
      toast.success(message, {
        toastId,
        position: 'top-center',
        autoClose: time,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const showWarning = (message, time = 5000) => {
    if (typeof message === 'object') {
      message = message.text;
    }

    if (toast.isActive(toastId)) {
      toast.update(toastId, {
        render: message,
        type: 'warning',
        autoClose: time,
        isLoading: false,
      });
    } else {
      toast.warning(message, {
        toastId,
        position: 'top-center',
        autoClose: time,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return { showError, showSuccess, showWarning };
};

export default useToastNotification;
